import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiMic, FiLink2, FiStar, FiMusic } = FiIcons;

const TYPES = {
  shoutout: { label: 'Shoutout', icon: FiMic,   color: 'text-blue-400',   bg: 'bg-blue-500/10 border-blue-500/20' },
  collab:   { label: 'Collab',   icon: FiMusic,  color: 'text-purple-400', bg: 'bg-purple-500/10 border-purple-500/20' },
  feature:  { label: 'Feature',  icon: FiStar,   color: 'text-amber-400',  bg: 'bg-amber-500/10 border-amber-500/20' },
  split:    { label: 'Split',    icon: FiLink2,  color: 'text-green-400',  bg: 'bg-green-500/10 border-green-500/20' },
};

const PromoTypeTag = ({ type }) => {
  const t = TYPES[type] || TYPES.shoutout;
  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full border text-[10px] font-black uppercase tracking-widest ${t.bg} ${t.color}`}>
      <SafeIcon icon={t.icon} className="text-xs" />
      {t.label}
    </span>
  );
};

export default PromoTypeTag;